import {
  GET_EXERCISE,
  CREATE_EXERCISE,
  UPDATE_EXERCISE,
  DELETE_EXERCISE,
  axios,
  baseURL,
} from "./types";

// Helper: loginData se automatic token aur hospitalID nikalne ke liye
const getLoginDetails = () => {
  const loginData = JSON.parse(localStorage.getItem('loginData') || '{}');
  return {
    token: loginData.token || '',
    hospitalID: loginData.hospitalID || '' 
  };
};

// 1. GET ALL EXERCISES
export const getExercise = () => (dispatch) => {
  const { token, hospitalID } = getLoginDetails();
  
  return axios({
    method: "post",
    url: `${baseURL}/api/appointmentExercise/getall`,
    headers: { 
      Authorization: `Bearer ${token}`, 
      "Content-Type": "application/json" 
    },
    data: { hospitalID: hospitalID },
  })
  .then((res) => {
    // Agar response success hai tabhi dispatch karein
    if (res.data.success === 1 || res.data.status === true) {
      dispatch({ 
        type: GET_EXERCISE, 
        payload: res.data, 
        hospitalID: hospitalID 
      });
    }
    return res;
  })
  .catch((err) => { 
    console.error("Get Exercise Error:", err);
    throw err; 
  });
};

// 2. CREATE EXERCISE
export const createExercise = (formData) => (dispatch) => {
  const { token, hospitalID } = getLoginDetails();

  // FormData handle karne ke liye (kyunki aap image bhej rahe hain)
  let finalData;
  if (formData instanceof FormData) {
    finalData = formData;
    if (!finalData.has("hospitalID")) {
      finalData.append("hospitalID", hospitalID);
    }
  } else {
    finalData = { ...formData, hospitalID: hospitalID };
  }

  return axios({
    method: "post",
    url: `${baseURL}/api/appointmentExercise/create`,
    headers: { 
      Authorization: `Bearer ${token}`,
      // FormData hone par Content-Type set karne ki zaroorat nahi hoti, axios khud kar leta hai
      ...(formData instanceof FormData ? {} : { "Content-Type": "application/json" })
    },
    data: finalData,
  })
  .then((res) => {
    dispatch({ type: CREATE_EXERCISE, payload: res.data });
    dispatch(getExercise()); // List ko refresh karne ke liye
    return res;
  })
  .catch((err) => { 
    console.error("Create Exercise Error:", err);
    throw err; 
  });
};

// 3. UPDATE EXERCISE
export const updateExercise = (formData) => (dispatch) => {
  const { token, hospitalID } = getLoginDetails();

  let finalData;
  if (formData instanceof FormData) {
    finalData = formData;
    if (!finalData.has("hospitalID")) {
      finalData.append("hospitalID", hospitalID);
    }
  } else {
    finalData = { ...formData, hospitalID: hospitalID };
  }

  return axios({
    method: "patch",
    url: `${baseURL}/api/appointmentExercise/update`,
    headers: { 
      Authorization: `Bearer ${token}`,
      ...(formData instanceof FormData ? {} : { "Content-Type": "application/json" })
    },
    data: finalData,
  })
  .then((res) => {
    dispatch({ type: UPDATE_EXERCISE, payload: res.data });
    dispatch(getExercise()); // List ko refresh karne ke liye
    return res;
  })
  .catch((err) => { 
    console.error("Update Exercise Error:", err);
    throw err; 
  });
};

// 4. DELETE EXERCISE
export const deleteExercise = (data) => (dispatch) => {
  const { token, hospitalID } = getLoginDetails();
  
  return axios({
    method: "delete",
    url: `${baseURL}/api/appointmentExercise/delete`,
    headers: { 
      Authorization: `Bearer ${token}`, 
      "Content-Type": "application/json" 
    },
    // Delete API mein aksar { id: 123, hospitalID: 168 } bhejna hota hai
    data: { ...data, hospitalID: hospitalID },
  })
  .then((res) => {
    dispatch({ type: DELETE_EXERCISE, payload: res.data });
    dispatch(getExercise()); // Delete ke baad list update karein
    return res;
  })
  .catch((err) => { 
    console.error("Delete Exercise Error:", err);
    throw err; 
  });
};